module.exports = (c, suffixe = '--text') => $('.'+c+suffixe) && $('.'+c+suffixe).css('color') || 'rgb(0,44,66)'


// WEBPACK FOOTER //
// ./app/Utilitaire/Function/Color.js